import { useState, useEffect } from "react";

// Hint. 1=On Time, 2=At Risk, 3=Late, 4=Exception.
export default function useEtaStatus(statusId, exceptions, tabValue) {
  const [etaStatuses, setEtaStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState({});

  const allStatuses = [
    {
      id: -1,
      name: "",
      backgroundColor: ""
    },
    {
      id: 1,
      name: "On Time",
      backgroundColor: "success.60"
    },
    {
      id: 2,
      name: "At Risk",
      backgroundColor: "warning.70"
    },
    {
      id: 3,
      name: "Late",
      backgroundColor: "error.60"
    },
    {
      id: 4,
      name: "Exception",
      backgroundColor: "purple.60"
    }
  ];

  useEffect(() => {
    setEtaStatuses(allStatuses);
  }, []);

  useEffect(() => {
    let index = etaStatuses.findIndex(status => status.id === statusId);
    const hasExceptions = exceptions && (
      exceptions.missingDispatchStatus ||
      exceptions.missingArrivalTime ||
      exceptions.missingDepartureTime ||
      exceptions.missingTrailerException ||
      exceptions.missingTractorException
    );
    if (tabValue === 1 && statusId < 2 && hasExceptions) {
      index = etaStatuses.findIndex(status => status.id === 4);
    }
    setCurrentStatus(etaStatuses[index]);
  }, [statusId, etaStatuses, exceptions, tabValue]);

  return { etaStatuses, currentStatus };
}